import { Flex, Typography } from 'antd'
import { createStyles } from 'antd-style'
import type { ReactNode } from 'react'

const { Title, Text } = Typography

// Auth header type scale (anchored on the 13px body):
//   label 12 · body 13 · subtitle 13 · title 28  → display-to-subtitle
// contrast for a confident, intentional hierarchy.
const useStyles = createStyles(({ token }) => ({
  title: {
    // Override the antd h1 token sizing for the auth display header.
    // !important beats antd's Typography atomic CSS (skalx governance §13).
    fontSize: '28px !important',
    lineHeight: '1.15 !important',
    letterSpacing: '-0.02em',
    marginBottom: '0 !important'
  },
  subtitle: {
    color: token.colorTextSecondary,
    fontSize: 13,
    lineHeight: 1.55,
    maxWidth: 360
  }
}))

type Props = {
  title: ReactNode
  subtitle?: ReactNode
}

export const AuthHeader = ({ title, subtitle }: Props) => {
  const { styles } = useStyles()

  return (
    <Flex vertical gap={8}>
      <Title level={1} className={styles.title}>
        {title}
      </Title>
      {subtitle && <Text className={styles.subtitle}>{subtitle}</Text>}
    </Flex>
  )
}
